import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminContentCampaignRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'content.campaigns.'

  index() {
    return this.ziggyRoute('index')
  }

  show(campaignId: number) {
    return this.ziggyRoute('show', campaignId)
  }

  update(contentCampaignId: number) {
    return this.ziggyRoute('update', contentCampaignId)
  }

  saveProfit(contentCampaignId: number) {
    return this.ziggyRoute('save_profit', contentCampaignId)
  }

  updateCampaignManualDiscount(contentCampaignId: number) {
    return this.ziggyRoute('update_campaign_manual_discount', contentCampaignId)
  }

  getUpdatableAttributes(contentCampaignId: number) {
    return this.ziggyRoute('get_updatable_attributes', contentCampaignId)
  }

  destroy(contentCampaignId: number) {
    return this.ziggyRoute('destroy', contentCampaignId)
  }

  setToCanceled(contentCampaignId: number) {
    return this.ziggyRoute('set_status_as_canceled', contentCampaignId)
  }

  completed(contentCampaignId: number) {
    return this.ziggyRoute('completed', contentCampaignId)
  }

  exportExcel() {
    return this.ziggyRoute('export')
  }
}